import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "text-align-center sticky-table-header",
  "data-excelautofilter": "",
  border: "1",
  cellpadding: "5",
  style: {"border-collapse":"collapse","border":"1px solid black","caption-side":"top","margin-right":"5px","width":"100%"}
}
const _hoisted_2 = { class: "border-bottom-tr print-repeat print-frozen-row" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]

import { inject } from 'vue';

import {
  formatDateHelper,
  getPercent,
  myRoundNumber_helper,
  tableFormat,
} from '@/helpers/main_helper';

import { IPosition } from '@/types/IPosition';


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyDetailTable',
  props: {
    positions: null,
    timeScaleMinutes: null,
    paramKey: null,
    nextParamKey: null
  },
  emits: ['displayDetail'],
  setup(__props: any, { emit }) {

const props = __props as {
  positions: IPosition[];
  timeScaleMinutes: number;
  paramKey: string;
  nextParamKey: string;
}




const toHours = inject('toHours') as (v: number) => number | undefined;
const getOnlyDate = inject('getOnlyDate') as (v: number) => string;

const COLUMNS = [
  {
    name: 'time',
    label: 'Дата',
    attrs: { 'class': ['text-left'], 'data-minwidth': 25 },
    format: (pos: IPosition) => `${getOnlyDate(pos.time / 1000)}`,
  },
  {
    name: 'interval',
    label: 'Интервал',
    attrs: {
      'class': ['text-left'],
      'style': { minWidth: '100px' },
      'data-minwidth': 25,
    },
    format: (pos: IPosition) =>
      `${formatDateHelper(
        new Date(pos.time - props.timeScaleMinutes * 60 * 1000),
        'hh:nn',
      )} - ${formatDateHelper(new Date(pos.time), 'hh:nn')}`,
  },
  {
    name: 'value',
    label: 'м/ч',
    attrs: {
      'class': ['text-center'],
      'data-minwidth': 25,
      'data-formatnum': 7,
    },
    format: (pos: IPosition) =>
      `${myRoundNumber_helper(
        toHours(pos[props.paramKey][props.nextParamKey]),
        2,
      )}`,
    onClick(pos: IPosition) {
      const from = pos.time - props.timeScaleMinutes * 60 * 1000;
      const to = pos.time;
      emit('displayDetail', { from, to });
    },
  },
  {
    name: 'percent',
    label: '% от общего',
    attrs: {
      'class': ['text-right'],
      'data-minwidth': 25,
      'data-formatnum': 6,
    },
    format: (pos: IPosition) =>
      `${getPercent(
        pos[props.paramKey][props.nextParamKey],
        pos.engine_time,
      )}%`,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(COLUMNS, (col) => {
          return _createElementVNode("th", _mergeProps({
            key: col.name,
            class: "bg-grey-4"
          }, col.attrs, {
            innerHTML: col.label
          }), null, 16, _hoisted_3)
        }), 64))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.positions, (pos, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(COLUMNS, (col) => {
            return _createElementVNode("td", _mergeProps({
              key: col.name
            }, col.attrs, {
              onClick: () => col.onClick && col.onClick(pos)
            }), [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'my-link': col.onClick }]),
                innerHTML: _unref(tableFormat)(col.format(pos))
              }, null, 10, _hoisted_5)
            ], 16, _hoisted_4)
          }), 64))
        ]))
      }), 128))
    ])
  ]))
}
}

})